export default __webpack_public_path__ + "static/media/amplify.bc85fcf7.jpg";